export default __webpack_public_path__ + "81762b0b1aacd3686a6b1342b34e1f26.svg";